import React from 'react';
import { BookOpenIcon, GiftIcon, CheckIcon, TrophyIcon } from 'lucide-react';
import { OfferBlock } from './OfferBlock';
import { offerIncludes, IMAGES } from '../data/content';
export function Pricing() {
  return <section id="offer" className="bg-canvas px-5 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-227" data-mp="2ohnzw6dhv8mm">
      <div className="mx-auto max-w-2xl" data-id="element-228" data-mp="2jkxi9em1k4z3">
        <p className="mx-auto flex w-fit items-center gap-2 rounded-full bg-navy-900 px-4 py-1.5 text-sm font-bold uppercase tracking-wider text-radar" data-id="element-229" data-mp="2jlyvnpqj53jz">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-230" data-mp="1rthvnkkhii8v" />
          Special launch offer
        </p>
        <h2 id="pricing-title" className="mt-5 text-center font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-231" data-mp="25t0shh7ui75v">
          Here's everything you'll receive today
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white ring-2 ring-navy-900" data-id="element-232" data-mp="3h97mm09av4td">
          <img src={IMAGES.product} alt="Implant Risk Radar™ complete bundle" className="w-full bg-canvas" data-id="element-233" data-mp="3cae8c5m6v9s5" />

          <div className="divide-y divide-navy-900/10 px-5 sm:px-8" data-id="element-234" data-mp="3w1t6ps836v5l">
            <div className="flex items-center justify-between gap-4 py-5" data-id="element-235" data-mp="4rksdr36jx2a">
              <span className="flex items-center gap-3 text-[17px] font-semibold text-ink" data-id="element-236" data-mp="9ta3t7ubecqw">
                <BookOpenIcon className="h-6 w-6 shrink-0 text-radar-deep" aria-hidden="true" data-id="element-237" data-mp="erlf7n09cvb8" />
                Implant Risk Radar™ — 6 Premium Volumes
              </span>
              <span className="shrink-0 font-semibold text-muted line-through decoration-alert" data-id="element-238" data-mp="3i81zwrlqppdk">$97</span>
            </div>
            <div className="flex items-center justify-between gap-4 py-5" data-id="element-239" data-mp="3n6vb2ddk14ak">
              <span className="flex items-center gap-3 text-[17px] font-semibold text-ink" data-id="element-240" data-mp="3rxlgtrpw795s">
                <GiftIcon className="h-6 w-6 shrink-0 text-alert-deep" aria-hidden="true" data-id="element-241" data-mp="2uihbht6thzww" />
                5 Exclusive Professional Bonuses
              </span>
              <span className="shrink-0 font-semibold text-muted line-through decoration-alert" data-id="element-242" data-mp="2zfzphxzoz5br">$197</span>
            </div>
            <div className="flex items-center justify-between gap-4 py-5" data-id="element-243" data-mp="2rei9qdls0fpl">
              <span className="font-display text-xl font-bold uppercase text-navy-900" data-id="element-244" data-mp="2mh8koz2au62a">Total value</span>
              <span className="font-display text-2xl font-bold text-alert-deep line-through" data-id="element-245" data-mp="315wdwyooa3p2">$294</span>
            </div>
          </div>

          <div className="bg-navy-900 px-5 py-8 text-center sm:px-8" data-id="element-246" data-mp="28hqt6bxmcep8">
            <p className="text-lg text-white/80" data-id="element-247" data-mp="28k3aqnzgsn1r">But today, you can get complete access to everything for:</p>
            <p className="mt-2 font-display text-7xl font-bold leading-none text-white sm:text-8xl" data-id="element-248" data-mp="23la7rpht0efu">
              $27 <span className="text-3xl text-radar" data-id="element-249" data-mp="2dh3eutcr7fq8">USD</span>
            </p>
            <p className="mt-2 text-sm font-bold uppercase tracking-widest text-radar" data-id="element-250" data-mp="2dj6fs8fg2t9q">One-time payment</p>

            <ul className="mx-auto mt-6 grid max-w-md grid-cols-1 gap-2 text-left min-[400px]:grid-cols-2" data-id="element-251" data-mp="3txg10toe41wc">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-2 text-[15px] font-medium text-white" data-id="element-252" data-mp="9c60av0wmw0">
                  <CheckIcon className="h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-253" data-mp="5a9pcqrrrmz3" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="px-5 py-8 sm:px-8" data-id="element-254" data-mp="3rhq5nff94p3o">
            <p className="mb-7 text-center text-[16px] leading-relaxed text-muted" data-id="element-255" data-mp="3rihxqg9n44p7">
              That's less than many clinicians spend on a single lunch — for a reference system you can return to
              whenever you're preparing for a difficult implant case.
            </p>
            <OfferBlock label="Get Implant Risk Radar™ for $27" meta="One-time payment · Immediate access · 7-Day Guarantee" data-id="element-256" data-mp="a6gy0rbjvckq" />
          </div>
        </div>
      </div>
    </section>;
}